<template>
    <div ref="wrapperElement">
        <v-row no-gutters>
            <v-col v-for="(item, itemIndex) in props.items" :key="itemIndex" class="d-flex child-flex" cols="12" sm="6" md="4" lg="3">
                <a :href="`${item}?width=2500`"
                   :data-pswp-width="imageDimensions[itemIndex]?.width"
                   :data-pswp-height="imageDimensions[itemIndex]?.height"
                   class="pa-2 d-block w-full" target="_blank" data-cropped="true">
                    <v-img :src="`${item}?width=1000`"
                           :alt="`Bild ${itemIndex + 1}`"
                           :ref="el => {imageComponents[itemIndex] = el}"
                           @load="handleLoadedImage(itemIndex)"
                           aspect-ratio="1" cover/>
                </a>
            </v-col>
        </v-row>
    </div>
</template>

<script setup lang="ts">
import PhotoSwipeLightbox from 'photoswipe/lightbox';

const props = defineProps<{
    items: string[]
}>();

const wrapperElement = ref(null);
const imageComponents = ref([]);
const imageDimensions = ref([]);

onMounted(() => {
    const lightbox = new PhotoSwipeLightbox({
        gallery: wrapperElement.value,
        children: 'a',
        pswpModule: () => import('photoswipe')
    });
    lightbox.init();
});

function handleLoadedImage(index: number) {
    const imageComponent = imageComponents.value[index];
    if (imageComponent) {
        imageDimensions.value[index] = {
            width: imageComponent.naturalWidth,
            height: imageComponent.naturalHeight
        };
    }
}

</script>

<style lang="scss">
@import 'photoswipe/dist/photoswipe.css';
</style>